
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 488 488"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M64.192 108.444h359.617c29.943 0 54.223-24.278 54.223-54.222C478.031 24.278 453.754 0 423.809 0H64.192C34.248 0 9.969 24.278 9.969 54.222c0 29.944 24.279 54.222 54.223 54.222zM423.809 189.778H64.192c-29.944 0-54.223 24.278-54.223 54.222 0 29.943 24.278 54.223 54.223 54.223h359.617c29.945 0 54.223-24.279 54.223-54.223-.001-29.944-24.278-54.222-54.223-54.222zM423.809 379.557H64.192c-29.944 0-54.223 24.277-54.223 54.222C9.969 463.722 34.248 488 64.192 488h359.617c29.945 0 54.223-24.278 54.223-54.222-.001-29.944-24.278-54.221-54.223-54.221z","fill":"gray","data-original":"#000000"}})])])
          )
        }
      }
    